export default __webpack_public_path__ + "static/media/whatsappIcon.c75084c4.png";